"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextAfters = void 0;
var getFromMap_1 = require("./getFromMap");
var getNextAfters = function (node, map, settings) {
    return getFromMap_1.getFromMap(node[settings.nextAfterAccessor], map);
};
exports.getNextAfters = getNextAfters;
//# sourceMappingURL=getNextAfters.js.map